import { StoryType } from '@app/utils/models/story-type.model';

// Every story type, plus the filters that are not a type. The types reference StoryType so the two can't drift apart.
export enum StoryFilter {
  EditorPick = StoryType.EditorPick,
  Event = StoryType.Event,
  Highlighted = 'highlighted',
  Hotel = StoryType.Hotel,
  Insider = StoryType.Insider,
  IsBookmarked = 'is_bookmarked',
  Trip = StoryType.Trip,
  TripNearBy = 'trip_near_by',
}
